import type { ReactNode } from 'react'
import { Phone, Watch } from '../DeviceFrames'

// The intro's slides (IntroPager): a claim, a sentence, and the recording of
// the real app that shows it (the landing's clips, components/DeviceFrames).

export interface IntroSlide { title: string[]; body: string; devices: () => ReactNode }

export const INTRO_SLIDES: IntroSlide[] = [
  {
    title: ['One list.', 'Every phone.'],
    body: 'Anna adds milk. You see it before she puts her phone down, and on your watch too.',
    devices: () => (
      <div className="ml-fr__devices ml-fr__devices--pair">
        <Phone shot="phone-together" clip="phone-together" group="fr-together" />
        <Watch shot="watch-together" clip="watch-together" group="fr-together" />
      </div>
    ),
  },
  {
    title: ['Your store.', 'In order.'],
    body: 'Start shopping and the list follows the aisles. It learns the way you walk them.',
    devices: () => <div className="ml-fr__devices"><Phone shot="phone-shopping" clip="phone-shopping" /></div>,
  },
  {
    title: ['Shop from', 'your wrist.'],
    body: 'The list on your Garmin, an aisle at a time. A tick per item, both hands free for the trolley.',
    devices: () => <div className="ml-fr__devices ml-fr__devices--watch"><Watch shot="watch-shopping" clip="watch-shopping" /></div>,
  },
  {
    title: ['A link becomes', 'a list.'],
    body: 'Paste a recipe and its ingredients land on the list, each in its aisle.',
    devices: () => <div className="ml-fr__devices"><Phone shot="phone-recipe" clip="phone-recipe" /></div>,
  },
]
